module.exports = __webpack_public_path__ + "img/user1.32204001.png";